import {
  makeStyles,
  Card,
  Grid,
  ButtonBase,
  Theme,
  createStyles,
} from '@material-ui/core';
import { colors } from 'design-system';
import NetworkIndicator from '../../../../General/NetworkIndicator';

type Props = {
  paymentAmount: number;
  montlyPayment: number;
  totalPayment: number;
  requesting?: boolean;
  onRecalculate: () => void;
  onCreateQuotation: () => void;
};

const constantHeight = 177;

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    cardRoot: {
      backgroundColor: colors.madison,
      borderRadius: '0px 0px 20px 20px',
      color: colors.white,
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      minHeight: constantHeight,
      zIndex: theme.zIndex.appBar,
    },
    spacingToolbar: {
      height: constantHeight - theme.spacing(2),
    },
    generalContent: {
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 0,
      paddingBottom: 13,
      width: '100%',
    },
    topTitle: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '24px',
      padding: 12,
    },
    mediumText: {
      fontSize: 18,
      fontWeight: 300,
      lineHeight: '27px',
    },
    smallText: {
      fontSize: 12,
      fontWeight: 'normal',
      lineHeight: '18px',
    },
    largeText: {
      fontWeight: 800,
      fontSize: 22,
      lineHeight: '33px',
    },
    separator: {
      width: '100%',
      height: 1,
      backgroundColor: colors.white,
      margin: '15px 0',
    },
  }),
);

const FixedTopQuoteResume = ({
  paymentAmount,
  montlyPayment,
  totalPayment,
  onRecalculate,
  onCreateQuotation,
  requesting = false,
}: Props): JSX.Element => {
  const classes = useStyle();
  return (
    <>
      {/* Additional space to prevent the content from rendering behind it */}
      <div className={classes.spacingToolbar} />

      {/* The actual content */}
      <Card className={classes.cardRoot}>
        <NetworkIndicator
          requesting={requesting}
          message="Recalculando cotización..."
          whiteVariant
        />
        {!requesting && (
          <Grid container spacing={0}>
            <Grid
              container
              alignItems="center"
              justifyContent="center"
              item
              xs={12}
            >
              <span className={classes.topTitle}>
                Personalice su Cotización
              </span>
            </Grid>
            <div className={classes.generalContent}>
              <Grid container>
                <Grid item xs={6} container>
                  <Grid item xs={12}>
                    <span className={classes.mediumText}>
                      {paymentAmount} Cuotas
                    </span>
                  </Grid>
                  <Grid item xs={12}>
                    <span className={classes.largeText}>
                      ${montlyPayment.toFixed(2)}
                    </span>
                    &nbsp;
                    <span className={classes.smallText}>/ mes</span>
                  </Grid>
                </Grid>
                <Grid item xs={6} container justifyContent="flex-end">
                  <div style={{ display: 'inline' }}>
                    <span className={classes.mediumText}>Total</span>
                    <br />
                    <span className={classes.largeText}>
                      ${totalPayment.toFixed(2)}
                    </span>
                    &nbsp;
                    <span className={classes.smallText}>/ anual</span>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <div className={classes.separator} />
                </Grid>
                <Grid item xs={6}>
                  <ButtonBase
                    data-testid="recalculate-button"
                    disableRipple
                    onClick={onRecalculate}
                  >
                    <span className={classes.mediumText}>Recalcular</span>
                  </ButtonBase>
                </Grid>
                <Grid item xs={6} container justifyContent="flex-end">
                  <ButtonBase
                    data-testid="create-quotation-button"
                    disableRipple
                    onClick={onCreateQuotation}
                  >
                    <span className={classes.mediumText}>Crear Cotización</span>
                  </ButtonBase>
                </Grid>
              </Grid>
            </div>
          </Grid>
        )}
      </Card>
    </>
  );
};
export default FixedTopQuoteResume;
